import type { FinancialStatementInventoryType } from '@api';
import { TabsType } from '@terminal/modules/tab-content/types';
import { appPaths } from '@terminal/routes/app-paths';
import { queryKeys } from '@terminal/routes/query-params';
import { t } from 'i18next';

export const STATEMENT_TO_QUERY_PARAM: Record<
  FinancialStatementInventoryType,
  string
> = {
  income: 'incomeStatement',
  cashflow: 'cashFlow',
  balancesheet: 'balanceSheet',
};

const STATEMENT_I18N_KEYS: Record<FinancialStatementInventoryType, string> = {
  income: 'chat:financialStatement.income',
  cashflow: 'chat:financialStatement.cashflow',
  balancesheet: 'chat:financialStatement.balancesheet',
};

export const getStatementDisplayLabel = (
  statement: FinancialStatementInventoryType
): string => t(STATEMENT_I18N_KEYS[statement]);

export interface FinancialStatementItem {
  entityTag: string;
  statement?: FinancialStatementInventoryType;
}

export const getAssetOverviewFinancialsUrl = (
  entityTag: string,
  baseUrl: string,
  statement?: FinancialStatementInventoryType
): string => {
  const params = new URLSearchParams();
  params.set(queryKeys.assetOverviewAsset, entityTag);
  params.set(queryKeys.assetOverviewTab, TabsType.Financials);
  if (statement) {
    params.set(
      queryKeys.activeFinancialsStatement,
      STATEMENT_TO_QUERY_PARAM[statement]
    );
  }
  return `${baseUrl}${appPaths.assetOverview}?${params.toString()}`;
};

export interface FinancialStatementRawItem {
  tag: string;
  statement?: FinancialStatementInventoryType;
}

export const normalizeFinancialStatementItems = (
  rawItems: FinancialStatementRawItem[]
): FinancialStatementItem[] =>
  rawItems.map(item => ({
    entityTag: item.tag,
    statement: item.statement,
  }));
